import { atom } from 'jotai';

export const paymentMethodAtom = atom('credit');
